import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { CurrentUserBootstrapService } from '../current-user-bootstrap.service';
import { CurrentUserStore } from '../current-user.store';
import { redirectForBlockedSession } from './session-guard-redirects';

export const redirectByAppStateGuard: CanActivateFn = async (_route, state) => {
  const bootstrap = inject(CurrentUserBootstrapService);
  const router = inject(Router);
  const store = inject(CurrentUserStore);
  const result = await bootstrap.ensureSession();

  if (result.status === 'active' || result.status === 'onboarding-required') {
    return router.parseUrl(result.redirectTo ?? store.resolveDefaultRedirectUrl());
  }

  return redirectForBlockedSession(result, router, store, state.url);
};
